var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink2DiagonalGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.42 7.33064L6.52046 17.2301C5.73942 18.0112 4.47309 18.0112 3.69204 17.2301C2.91099 16.4491 2.91099 15.1828 3.69204 14.4017L13.238 4.85577C14.8001 3.29367 17.3327 3.29367 18.8948 4.85577C20.4569 6.41787 20.4569 8.95053 18.8948 10.5126L12.5309 16.8766",
    stroke: "url(#paint0_linear_9661_100289)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9661_100289",
    x1: 20.519,
    y1: -8.85989,
    x2: 29.466,
    y2: 11.6374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0202A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2DiagonalGradient);
export default __webpack_public_path__ + "static/media/link-2-diagonal-gradient.4ad99f85cd0202dc77ed2f2240eb2ffe.svg";
export { ForwardRef as ReactComponent };